'use client';
import React from 'react';
import { Download, Share2, Eye } from 'lucide-react';
import { toast } from 'sonner';

const CERTIFICATES = [
  { id: 'cert-001', title: 'Dog of the Day', category: 'Community', date: 'June 1, 2026', bg: 'from-amber-400 to-amber-600', emoji: '🏆' },
  { id: 'cert-002', title: '7th Birthday Star', category: 'Birthday', date: 'May 3, 2026', bg: 'from-pink-400 to-rose-500', emoji: '🎂' },
  { id: 'cert-003', title: 'Beloved Companion', category: 'Achievement', date: 'March 14, 2026', bg: 'from-violet-500 to-purple-700', emoji: '❤️' },
  { id: 'cert-004', title: 'Agility Champion', category: 'Milestone', date: 'March 22, 2026', bg: 'from-blue-400 to-cyan-600', emoji: '🏅' },
  { id: 'cert-005', title: 'Community Favorite', category: 'Hall of Fame', date: 'April 7, 2026', bg: 'from-green-400 to-emerald-600', emoji: '⭐' },
  { id: 'cert-006', title: 'Founding Dog', category: 'Exclusive', date: 'January 1, 2026', bg: 'from-amber-600 to-orange-700', emoji: '🏅' },
];

export default function DogCertificates() {
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-700 text-foreground">Certificates</h2>
        <span className="text-sm text-muted-foreground">6 certificates earned</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {CERTIFICATES?.map((cert) => (
          <div key={cert?.id} className="bg-card border border-border rounded-2xl overflow-hidden shadow-card card-hover group">
            {/* Certificate preview */}
            <div className={`relative h-40 bg-gradient-to-br ${cert?.bg} flex flex-col items-center justify-center gap-2`}>
              <span className="text-5xl">{cert?.emoji}</span>
              <p className="text-white font-800 text-sm text-center px-4">{cert?.title}</p>
              <p className="text-white/70 text-xs">{cert?.category}</p>
              {/* Hover overlay */}
              <div className="absolute inset-0 bg-foreground/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-3">
                <button
                  onClick={() => toast?.success('Opening certificate preview...')}
                  className="w-9 h-9 bg-white rounded-full flex items-center justify-center hover:bg-muted transition-colors"
                  title="View certificate"
                >
                  <Eye size={16} className="text-foreground" />
                </button>
                <button
                  onClick={() => toast?.success('Downloading certificate...')}
                  className="w-9 h-9 bg-white rounded-full flex items-center justify-center hover:bg-muted transition-colors"
                  title="Download certificate"
                >
                  <Download size={16} className="text-foreground" />
                </button>
                <button
                  onClick={() => toast?.success('Share link copied!')}
                  className="w-9 h-9 bg-white rounded-full flex items-center justify-center hover:bg-muted transition-colors"
                  title="Share certificate"
                >
                  <Share2 size={16} className="text-foreground" />
                </button>
              </div>
            </div>
            <div className="p-4">
              <p className="font-700 text-sm text-foreground">{cert?.title}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{cert?.date}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}